<div *ngIf="timeSlots && timeSlots.length" class="row justify-content-between page-container-content page-container-content-small">
  <div *ngFor="let timeSlot of timeSlots" class="col-12 col-md-6" [ngClass]="{elinactive: (timeSlot.freeQuantity==0)}">
    <a (click)="onClickTimeSlot(timeSlot)">
      <div class="ng-box">
        <div class="container">
          <div class="row box-bar">
              <div class="col">
                <h3 class="time-box"><app-time-slot-box [bookingSlot]="timeSlot"></app-time-slot-box></h3>
                <div class="time-hours" *ngFor="let minutes of getAreaItemsTimeMinutes(timeSlot)">
                  <app-time-length-label *ngIf="isShowTimeSlotLength" [minutes]="minutes"></app-time-length-label>
                  <div class="available-quantity" *ngIf="isShowAvailableTicketsInTimeSlot">{{ getAreaItemAvailableQuantity(timeSlot, minutes)}} {{ "Tickets left" | translate }}</div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </a>
  </div>
